$(document).ready(function () {
  const search = $('.js-pc-search');
  const menu = $('.js-pc-menu');
  const categoryTitles = $('.js-pc-category-title');
  const categoryContents = $('.js-pc-category-content');

  search.on('mouseenter', () => {
    search.find('p').addClass('border-black');
    search.find('p').removeClass('border-transparent');
    menu.show();
  });

  menu.on('mouseleave', () => {
    search.find('p').removeClass('border-black');
    search.find('p').addClass('border-transparent');
    menu.hide();
  });

  categoryTitles.map((index, title) => {
    $(title).on('mouseenter', () => {
      $('.js-current').hide();
      $('.js-current').removeClass('js-current');
      $(categoryContents[index]).show();
      $(categoryContents[index]).addClass('js-current');
    });
  });
});
